'use client';

import { Center, Spinner } from '@chakra-ui/react';

import { IframeLoginPrompt } from './IframeLoginPrompt';
import { useIframeLoginFlow } from './useIframeLoginFlow';

function LoginPage() {
  const { handlePopupLogin, popupBlocked, showIframeLoginPrompt } =
    useIframeLoginFlow();

  if (showIframeLoginPrompt) {
    return (
      <IframeLoginPrompt
        popupBlocked={popupBlocked}
        onContinue={handlePopupLogin}
      />
    );
  }

  return (
    <Center h="100vh">
      <Spinner />
    </Center>
  );
}

export default LoginPage;
